<template>
    <v-container
      class="fill-height mb-10"
    >
      <v-row
        justify="center"
        align="center"
      >
        <v-col
          cols="12"
          md="8"
        >
          <v-card class="elevation-5" v-if="!isMailSended">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <v-form @submit.prevent="handleSubmit(submit)">
                <v-toolbar
                  color="indigo"
                  class="lighten-1"
                  dark
                  flat
                >
                  <v-toolbar-title>Восстановление доступа к кабинету
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <ValidationProvider name="detail" v-slot="{ errors }">
                    <v-alert
                      dense
                      outlined
                      type="error"
                      v-show="errors[0]"
                    >
                      <div v-html="errors[0]" class="caption"></div>
                    </v-alert>
                  </ValidationProvider>
                  <ValidationProvider name="email" rules="required|email|max:254" v-slot="{ errors }">
                    <v-text-field
                      name="email"
                      v-model="email"
                      :error-messages="errors"
                      type="text"
                      label="Электронная почта"
                    ></v-text-field>
                  </ValidationProvider>
                </v-card-text>
                <v-card-actions>
                  <help-password-recovery></help-password-recovery>
                  <v-spacer></v-spacer>
                  <v-btn
                    right
                    dark
                    class="lighten-1"
                    color="ma-2 indigo"
                    type="submit"
                    :loading="isLoading"
                  >
                    Далее
                  </v-btn>
                </v-card-actions>
              </v-form>
            </ValidationObserver>
          </v-card>

          <v-card class="elevation-5" v-else>
            <v-toolbar
              color="indigo"
              class="lighten-1"
              dark
              flat
            >
              <v-toolbar-title>Восстановление доступа к кабинету
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              Мы отправили на электронную почту:<br>
              <span class="font-weight-bold">{{email}}</span><br>
              письмо с дальнейшими инстукциями по сбросу пароля к личному кабинету.
            </v-card-text>
            <v-card-actions>
              <help-password-recovery></help-password-recovery>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
  import {extend, localize, ValidationObserver, ValidationProvider} from "vee-validate";
  import HelpPasswordRecovery from '@/components/auth/dialogs/HelpPasswordRecovery'
  import {mapGetters} from "vuex";
  import {email, max, required} from "vee-validate/dist/rules";

  localize({
    ru: {
      names: {
        email: ' ',
        password: ' ',
      }
    }
  });

  extend('required', {
    ...required
  });
  extend('email', {
    ...email
  });
  extend('max', {
    ...max
  });

  export default {
    name: "PasswordRecovery",
    components: {
      ValidationProvider,
      ValidationObserver,
      HelpPasswordRecovery,
    },
    data() {
      return {
        email: null,
        isMailSended: false,
      }
    },
    computed: {
      ...mapGetters("context", [
        'isLoading',
        'messages',
      ]),
    },
    methods: {
      async submit() {
        await this.$refs.observer.validate()
          .then(success => {
            if (!success) {
              return;
            }

            const {email} = this
            this.$store.commit("context/CLEAR_MESSAGES");
            this.$store.dispatch("auth/password_recovery", {email})
              .then(() => {
                if (this.messages) {
                  this.$refs.observer.setErrors(this.messages);
                } else {
                  this.isMailSended = true;
                }
              })
              .catch(() => {
                this.$refs.observer.setErrors({
                  'detail': 'Неизвестная ошибка. Обратитесь в поддержку: <a href="mailto:abit@kuzstu.ru">abit@kuzstu.ru</a>',
                  'email': ' ',
                  'password': ' ',
                });
              })

            this.$nextTick(() => {
              this.$refs.observer.reset();
            });
          })
      }
    }
  }
</script>

<style>

</style>

